import { render, staticRenderFns } from "./Atlas_Desktop.vue?vue&type=template&id=f2996fea&scoped=true&"
import script from "./Atlas_Desktop.vue?vue&type=script&lang=js&"
export * from "./Atlas_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Atlas_Desktop.vue?vue&type=style&index=0&id=f2996fea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2996fea",
  null
  
)

export default component.exports